
import { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export const useReferralTracking = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const processingRef = useRef(false);
  const redirectCountRef = useRef(0);
  
  // Check for referral codes in URL and save them
  useEffect(() => {
    if (processingRef.current) return; // Prevent recursive processing
    
    const queryParams = new URLSearchParams(location.search);
    
    // Check for referral from either 'via' (Rewardful format) or 'ref' (our current format)
    const referralId = queryParams.get('via') || queryParams.get('ref');
    
    console.log('[REFERRAL] URL params check:', { 
      via: queryParams.get('via'), 
      ref: queryParams.get('ref'), 
      referralId,
      fullURL: window.location.href 
    });
    
    if (referralId) {
      // Save to localStorage for persistence between page navigations
      localStorage.setItem('rewardful_referral_id', referralId);
      sessionStorage.setItem('rewardful_referral_id', referralId);
      console.log('[REFERRAL] Referral ID detected and saved:', referralId);
      
      // Si detectamos un referido de Rewardful (via parameter), aplicar descuento del 30%
      if (queryParams.get('via')) {
        // Guardar que tiene descuento por referido
        localStorage.setItem('referral_discount', '30');
        sessionStorage.setItem('referral_discount', '30');
        console.log('[REFERRAL] Rewardful referral detected, applying 30% discount');
      }
      
      // If the URL contains referral parameters but we're not on the root/landing page,
      // we want to preserve the referral even if the user navigates directly to another page
      if (location.pathname !== '/') {
        localStorage.setItem('referral_landing_path', location.pathname);
      }
    } else {
      // Si no hay un parámetro de referido en la URL pero tenemos uno almacenado,
      // SÓLO añadir a la URL en páginas críticas como registro y checkout,
      // y sólo si no estamos procesando ya una redirección
      const storedReferralId = localStorage.getItem('rewardful_referral_id');
      const isImportantPage = location.pathname === '/registro' || 
                             location.pathname === '/login' || 
                             location.pathname.includes('payment');
      
      console.log('[REFERRAL] Checking stored referral:', { 
        storedReferralId, 
        isImportantPage, 
        currentPath: location.pathname 
      });
      
      if (storedReferralId && 
          isImportantPage && 
          !sessionStorage.getItem('referral_redirect_in_progress')) {
        
        // Máximo 1 redirección por sesión para evitar loops
        const redirectCount = redirectCountRef.current;
        
        if (redirectCount < 1) {
          redirectCountRef.current += 1;
          processingRef.current = true;
          sessionStorage.setItem('referral_redirect_in_progress', 'true');
          
          // Keep any existing query parameters
          const newQueryParams = new URLSearchParams(location.search);
          newQueryParams.set('via', storedReferralId);
          
          console.log('[REFERRAL] Adding referral to URL:', storedReferralId);
          
          // Navigate to the same path but with referral parameter
          navigate({
            pathname: location.pathname,
            search: newQueryParams.toString(),
          }, { replace: true });
          
          // Clean up the redirect flag after a short delay
          setTimeout(() => {
            processingRef.current = false;
            sessionStorage.removeItem('referral_redirect_in_progress');
          }, 1000);
        } else {
          console.log('[REFERRAL] Máximo de redirecciones alcanzado');
        }
      }
    }
    
    // Reinicia el contador después de 5 minutos para permitir redirecciones futuras
    setTimeout(() => {
      redirectCountRef.current = 0;
    }, 5 * 60 * 1000);
    
  }, [location, navigate]);

  return null;
};
